import type { ChatRouteContext } from "@repo/agent-chat";

/**
 * The route context most recently seen by a mounted `AgentChat.Root`, read by
 * the shared transport at send time.
 *
 * A thread's transport is built once and lives in the chat registry, outliving
 * every surface that renders it, so it cannot close over a component ref the
 * way the per-mount transport used to. Module scope is the honest home: there
 * is one clinician looking at one route at a time, so "where the request is
 * being sent from" is genuinely global rather than per-surface. Every mounted
 * `Root` writes the same value from the same router state, so concurrent
 * surfaces agree by construction.
 */
let current: ChatRouteContext = {};

export function setChatRouteContext(context: ChatRouteContext): void {
  current = context;
}

export function getChatRouteContext(): ChatRouteContext {
  return current;
}
